/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Amount excl. tax set on a tunnel fee.
 * @export
 * @interface RetarificationFraisValeurDto
 */
export interface RetarificationFraisValeurDto {
    /**
     * 
     * @type {string}
     * @memberof RetarificationFraisValeurDto
     */
    remunerationTunnelId: string;
    /**
     * 
     * @type {number}
     * @memberof RetarificationFraisValeurDto
     */
    valeur: number;
}

/**
 * Check if a given object implements the RetarificationFraisValeurDto interface.
 */
export function instanceOfRetarificationFraisValeurDto(value: object): value is RetarificationFraisValeurDto {
    if (!('remunerationTunnelId' in value) || value['remunerationTunnelId'] === undefined) return false;
    if (!('valeur' in value) || value['valeur'] === undefined) return false;
    return true;
}

export function RetarificationFraisValeurDtoFromJSON(json: any): RetarificationFraisValeurDto {
    return RetarificationFraisValeurDtoFromJSONTyped(json, false);
}

export function RetarificationFraisValeurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationFraisValeurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationTunnelId': json['remunerationTunnelId'],
        'valeur': json['valeur'],
    };
}

export function RetarificationFraisValeurDtoToJSON(json: any): RetarificationFraisValeurDto {
    return RetarificationFraisValeurDtoToJSONTyped(json, false);
}

export function RetarificationFraisValeurDtoToJSONTyped(value?: RetarificationFraisValeurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationTunnelId': value['remunerationTunnelId'],
        'valeur': value['valeur'],
    };
}

